import 'reflect-metadata';
import { INVESTUNIT_ID_TN_STR } from '@/src/utils/constants';
import { deserealizeInvestUnitType, fromPlutusDataInvestUnitType, toPlutusDataInvestUnitType } from '../Commons/conversions';
import { Convertible, asSmartDBEntity, type CS } from '../Commons/index.exports';
import { type TokensForInvestUnitDatum } from '../Commons/types';
import { BaseSmartDBEntity } from './index.exports';

@asSmartDBEntity()
export class InvestUnitEntity extends BaseSmartDBEntity {
    protected static _apiRoute: string = 'investunits';
    protected static _className: string = 'Invest Unit';
    // protected static _mongoTableName: string = 'Invest Unit';

    protected static _plutusDataIndex = 0;

    // #region fields

    _NET_id_TN_Str: string = INVESTUNIT_ID_TN_STR;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields

    // #region datum

    @Convertible({ isForDatum: true })
    iuVersion!: number;

    @Convertible({ isForDatum: true , type: String})
    iudFundPolicy_CS!: CS;

    @Convertible({
        isForDatum: true,
        fromPlainObject: deserealizeInvestUnitType,
        fromPlutusData: fromPlutusDataInvestUnitType,
        toPlutusData: toPlutusDataInvestUnitType,
    })
    iudInvestUnit!: TokensForInvestUnitDatum;

    @Convertible({ isForDatum: true })
    iudMinADA!: bigint;

    // #endregion datum

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {
    }

    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
        iudFundPolicy_CS: true,
        iudInvestUnit: true,
    };

    // #endregion  db

    // #region class methods

    public getNET_id_CS(): string {
        return this.iudFundPolicy_CS;
    }

    // #endregion class methods
}
